// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter+Tight&family=Montserrat&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html {
  height: 100%;
  margin: 0;
  padding: 0;
}
html,
body,
#root,
#root > div {
  height: 100%;
}
:root {
  --color-clicap: #2c4580;
  --color-clicap-grey: #bdbdbd;
  --color-clicap-greylight: #bdbdbd21;
  --color-clicap-hover: #a45701;
  --color-clicap-focus: rgb(200 106 2 / 50%);
  --color-icon-error: #ed2b2a;
  --color-blue-primary: #2864f6;
  --color-blue-secondary: #afd3e2;
}
.center-center {
  display: flex;
  justify-content: center;
  align-items: center;
}
.left-right {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding: 3px;
}
.h-100 {
  min-height: 100%;
}
.table thead th {
  /* border-bottom: 2px solid var(--color-clicap); */
  border-bottom: 2px solid #2864f6;
}
.icon-size-table {
  font-size: 1.2rem;
}
.btn-edit-table:hover {
  color: #3a4f7a;
}

.btn-delete-table:hover {
  color: #eb455f;
}
.btn-certificate-table:hover {
  color: #439a97;
}
.modal-50w {
  min-width: 50%;
}
.modal-80w {
  min-width: 80%;
}
.center-filters {
  display: flex;
  justify-content: center;
  align-items: flex-end;
}
.overflow-x {
  overflow-x: auto;
}

.color-icon-error {
  color: var(--color-icon-error);
}
.color-icon-edit {
  color: #146c94;
}
.color-blue-secondary {
  color: #146c94;
}

.btn-primary {
  background-color: #2864f6 !important;
  border-color: #2864f6 !important;
}

.btn-success {
  color: #fff;
  background-color: #198754 !important;
  border-color: #198754 !important;
}

.btn-primary:hover {
  background-color: #19a7ce !important;
  border-color: #19a7ce !important;
}

.btn-secondary {
  background-color: #ffff !important;
  border-color: #ffff !important;
  color: black !important;
}

.btn-secondary:hover {
  background-color: #19a7ce !important;
  border-color: #19a7ce !important;
}

.btn-success:hover {
  background-color: #157347 !important;
  border-color: #146c43 !important;
}

.color-success-strong-bk {
  background-color: #a4d0a4;
}
.color-success-smooth-bk {
  background-color: #a0d8b3;
}
.color-warning-strong-bk {
  background-color: #ffd95a;
}
.color-warning-smooth-bk {
  background-color: #f8e091;
}
.color-danger-strong-bk {
  background-color: #f13c3b;
}
.color-danger-smooth-bk {
  background-color: #ff9191;
}

.color-success-strong {
  color: #e5f9db;
}
.color-success-smooth {
  color: #617a55;
}
.color-warning-strong {
  color: #ffc400;
}
.color-warning-smooth {
  color: #f8e091;
}
.color-danger-strong {
  color: #f13c3b;
}
.color-danger-smooth {
  color: #ff9191;
}

.information-card {
  margin: 1.5rem 2rem;
  padding: 4rem;
  border-radius: 2rem;
  box-shadow: -1px -2px 40px 8px rgba(0, 0, 0, 0.14);
  -webkit-box-shadow: -1px -2px 40px 8px rgba(0, 0, 0, 0.14);
  -moz-box-shadow: -1px -2px 40px 8px rgba(0, 0, 0, 0.14);
  width: 45rem;
}

@media (max-width: 900px) {
  .information-card {
    width: 90vw;
  }
}

@media (max-width: 480px) {
  .overflow-x {
    overflow-x: auto;
  }
}

.information-card-area {
  margin: 1.5rem 2rem;
  padding: 2rem;
  border-radius: 2rem;
  box-shadow: -1px -2px 40px 8px rgba(0, 0, 0, 0.14);
  -webkit-box-shadow: -1px -2px 40px 8px rgba(0, 0, 0, 0.14);
  -moz-box-shadow: -1px -2px 40px 8px rgba(0, 0, 0, 0.14);
  width: 70%;
}

@media (max-width: 900px) {
  .information-card-area {
    width: 90vw;
  }
}

.fa-disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
.selector-container {
  width: 100%;
}

/* Opcionalmente, si deseas especificar el ancho máximo del selector */
.selector-container .Select {
  width: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAEA;EACE,YAAY;EACZ,SAAS;EACT,UAAU;AACZ;AACA;;;;EAIE,YAAY;AACd;AACA;EACE,uBAAuB;EACvB,4BAA4B;EAC5B,mCAAmC;EACnC,6BAA6B;EAC7B,0CAA0C;EAC1C,2BAA2B;EAC3B,6BAA6B;EAC7B,+BAA+B;AACjC;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,eAAe;EACf,8BAA8B;EAC9B,YAAY;AACd;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kDAAkD;EAClD,gCAAgC;AAClC;AACA;EACE,iBAAiB;AACnB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,qBAAqB;AACvB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;AAChC;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,kCAAkC;EAClC,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,kDAAkD;EAClD,0DAA0D;EAC1D,uDAAuD;EACvD,YAAY;AACd;;AAEA;EACE;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,kDAAkD;EAClD,0DAA0D;EAC1D,uDAAuD;EACvD,UAAU;AACZ;;AAEA;EACE;IACE,WAAW;EACb;AACF;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,WAAW;AACb;;AAEA,sEAAsE;AACtE;EACE,WAAW;AACb","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Inter+Tight&family=Montserrat&display=swap\");\n\nhtml {\n  height: 100%;\n  margin: 0;\n  padding: 0;\n}\nhtml,\nbody,\n#root,\n#root > div {\n  height: 100%;\n}\n:root {\n  --color-clicap: #2c4580;\n  --color-clicap-grey: #bdbdbd;\n  --color-clicap-greylight: #bdbdbd21;\n  --color-clicap-hover: #a45701;\n  --color-clicap-focus: rgb(200 106 2 / 50%);\n  --color-icon-error: #ed2b2a;\n  --color-blue-primary: #2864f6;\n  --color-blue-secondary: #afd3e2;\n}\n.center-center {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.left-right {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  padding: 3px;\n}\n.h-100 {\n  min-height: 100%;\n}\n.table thead th {\n  /* border-bottom: 2px solid var(--color-clicap); */\n  border-bottom: 2px solid #2864f6;\n}\n.icon-size-table {\n  font-size: 1.2rem;\n}\n.btn-edit-table:hover {\n  color: #3a4f7a;\n}\n\n.btn-delete-table:hover {\n  color: #eb455f;\n}\n.btn-certificate-table:hover {\n  color: #439a97;\n}\n.modal-50w {\n  min-width: 50%;\n}\n.modal-80w {\n  min-width: 80%;\n}\n.center-filters {\n  display: flex;\n  justify-content: center;\n  align-items: flex-end;\n}\n.overflow-x {\n  overflow-x: auto;\n}\n\n.color-icon-error {\n  color: var(--color-icon-error);\n}\n.color-icon-edit {\n  color: #146c94;\n}\n.color-blue-secondary {\n  color: #146c94;\n}\n\n.btn-primary {\n  background-color: #2864f6 !important;\n  border-color: #2864f6 !important;\n}\n\n.btn-success {\n  color: #fff;\n  background-color: #198754 !important;\n  border-color: #198754 !important;\n}\n\n.btn-primary:hover {\n  background-color: #19a7ce !important;\n  border-color: #19a7ce !important;\n}\n\n.btn-secondary {\n  background-color: #ffff !important;\n  border-color: #ffff !important;\n  color: black !important;\n}\n\n.btn-secondary:hover {\n  background-color: #19a7ce !important;\n  border-color: #19a7ce !important;\n}\n\n.btn-success:hover {\n  background-color: #157347 !important;\n  border-color: #146c43 !important;\n}\n\n.color-success-strong-bk {\n  background-color: #a4d0a4;\n}\n.color-success-smooth-bk {\n  background-color: #a0d8b3;\n}\n.color-warning-strong-bk {\n  background-color: #ffd95a;\n}\n.color-warning-smooth-bk {\n  background-color: #f8e091;\n}\n.color-danger-strong-bk {\n  background-color: #f13c3b;\n}\n.color-danger-smooth-bk {\n  background-color: #ff9191;\n}\n\n.color-success-strong {\n  color: #e5f9db;\n}\n.color-success-smooth {\n  color: #617a55;\n}\n.color-warning-strong {\n  color: #ffc400;\n}\n.color-warning-smooth {\n  color: #f8e091;\n}\n.color-danger-strong {\n  color: #f13c3b;\n}\n.color-danger-smooth {\n  color: #ff9191;\n}\n\n.information-card {\n  margin: 1.5rem 2rem;\n  padding: 4rem;\n  border-radius: 2rem;\n  box-shadow: -1px -2px 40px 8px rgba(0, 0, 0, 0.14);\n  -webkit-box-shadow: -1px -2px 40px 8px rgba(0, 0, 0, 0.14);\n  -moz-box-shadow: -1px -2px 40px 8px rgba(0, 0, 0, 0.14);\n  width: 45rem;\n}\n\n@media (max-width: 900px) {\n  .information-card {\n    width: 90vw;\n  }\n}\n\n@media (max-width: 480px) {\n  .overflow-x {\n    overflow-x: auto;\n  }\n}\n\n.information-card-area {\n  margin: 1.5rem 2rem;\n  padding: 2rem;\n  border-radius: 2rem;\n  box-shadow: -1px -2px 40px 8px rgba(0, 0, 0, 0.14);\n  -webkit-box-shadow: -1px -2px 40px 8px rgba(0, 0, 0, 0.14);\n  -moz-box-shadow: -1px -2px 40px 8px rgba(0, 0, 0, 0.14);\n  width: 70%;\n}\n\n@media (max-width: 900px) {\n  .information-card-area {\n    width: 90vw;\n  }\n}\n\n.fa-disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n.selector-container {\n  width: 100%;\n}\n\n/* Opcionalmente, si deseas especificar el ancho máximo del selector */\n.selector-container .Select {\n  width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
